import * as z from 'zod/v4';

export const externalWagerGuidSchema = z.uuid().brand<'ExternalWagerGuid'>();
export type ExternalWagerGuid = z.infer<typeof externalWagerGuidSchema>;
